import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import { CronJob } from '../../../globals/interfaces';
import BackButton from '../../../components/custom/BackButton';
import { createdUpdatedInfo, notify } from '../../../utils';
import ActionIcon from '../../../components/custom/ActionIcon';
import { FormGroup } from 'reactstrap';
import { Input } from 'reactstrap';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    selectedJob: CronJob | undefined;
    updateCronJob: (displayName: string, description: string) => Promise<void>;
}

export default function ModalUpdateCronJob({
    modal,
    setModal,
    selectedJob,
    updateCronJob
}: Props) {

    const [displayName, setDisplayName] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (!selectedJob) {
            return;
        }
        setDisplayName(selectedJob.displayName || '');
        setDescription(selectedJob.description || '');
    }, [selectedJob]);

    const toggle = () => setModal(!modal);

    const handleUpdate = async () => {
        await updateCronJob(displayName, description);
        setModal(false);
        notify('Updated');
    }

    if (!selectedJob) {
        return null;
    }

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Update Automation</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label>Display Name</Label>
                    <Input value={displayName} onChange={e => setDisplayName(e.target.value)} />
                </FormGroup>
                <FormGroup>
                    <Label>Description</Label>
                    <Input value={description} onChange={e => setDescription(e.target.value)} type={'textarea'} />
                </FormGroup>
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <Label>
                        {createdUpdatedInfo(selectedJob)}
                    </Label>
                    <FooterButtonsContainer>
                        <ActionIcon
                            type={'save'}
                            onClick={handleUpdate}
                            simulateLoading
                        />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;